var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-10 offset-xl-1"},[_c('div',{staticClass:"px-xl-4"},[(this.validationError)?_c('p',{staticClass:"error-message px-2 py-2 mb-2 rounded-xl font-weight-lighter"},[_vm._v(" "+_vm._s(_vm.$t(this.validationError))+" ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }